export default "__VITE_ASSET__DwQMDKix__"